import React from 'react';
import './Button.css';

/**
 * Button (기획서 §8.2)
 * variants: primary | secondary | outline | ghost | gradient
 * sizes:    sm | md | lg
 */
const Button = React.forwardRef(function Button(
  {
    variant = 'primary',
    size = 'md',
    pill = false,
    fullWidth = false,
    iconLeft = null,
    iconRight = null,
    as: Tag = 'button',
    className = '',
    children,
    ...rest
  },
  ref
) {
  const cls = [
    'ft-btn',
    `ft-btn--${variant}`,
    `ft-btn--${size}`,
    pill ? 'ft-btn--pill' : '',
    fullWidth ? 'ft-btn--full' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag ref={ref} className={cls} {...rest}>
      {iconLeft ? <span className="ft-btn__icon ft-btn__icon--left">{iconLeft}</span> : null}
      <span className="ft-btn__label">{children}</span>
      {iconRight ? <span className="ft-btn__icon ft-btn__icon--right">{iconRight}</span> : null}
    </Tag>
  );
});

export default Button;
